
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 65.4 61","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.7 34.7c1.5.7 1.5 1.8 0 2.4L35.4 49.2c-1.5.7-4 .7-5.5 0L2.7 37.1c-1.5-.7-1.5-1.8 0-2.4l27.2-12c1.5-.7 4-.7 5.5 0l27.3 12z","fill":"var(--brand-primary-dark)"}}),_c('path',{attrs:{"d":"M62.7 23.8c1.5.7 1.5 1.8 0 2.4L35.4 38.3c-1.5.7-4 .7-5.5 0L2.7 26.2c-1.5-.7-1.5-1.8 0-2.4l27.2-12c1.5-.7 4-.7 5.5 0l27.3 12z","fill":"var(--brand-primary)"}}),_c('path',{attrs:{"d":"M62.7 12.8c1.5.7 1.5 1.8 0 2.4L35.4 27.3c-1.5.7-4 .7-5.5 0L2.7 15.2c-1.5-.7-1.5-1.8 0-2.4L30 .8c1.5-.7 4-.7 5.5 0l27.2 12z","fill":"var(--brand-primary-light)"}}),_c('path',{attrs:{"fill":"#ed8a19","d":"M110.8 29.1l-20.3-9-12.4 5.5 32.7 14.5 32.7-14.5-12.4-5.5z"}}),_c('path',{staticClass:"st5",attrs:{"d":"M110.8 40.1l-20.3-9-12.4 5.4L110.8 51l32.7-14.5-12.4-5.4z"}}),_c('path',{staticClass:"st5",attrs:{"d":"M110.8 51l-20.3-9-12.4 5.5L110.8 62l32.7-14.5-12.4-5.5z"}})])
          )
        }
      }
    